var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenewalTrackingHamMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12925 12.2598H1.53231C0.68604 12.2598 0 12.9458 0 13.7921V24.5183C0 25.3645 0.68604 26.0506 1.53231 26.0506H6.12925C6.97552 26.0506 7.66156 25.3645 7.66156 24.5183V13.7921C7.66156 12.9458 6.97552 12.2598 6.12925 12.2598Z",
    fill: "#8DC63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8548 0H12.2579C11.4116 0 10.7256 0.68604 10.7256 1.53231V24.517C10.7256 25.3633 11.4116 26.0493 12.2579 26.0493H16.8548C17.7011 26.0493 18.3871 25.3633 18.3871 24.517V1.53231C18.3871 0.68604 17.7011 0 16.8548 0Z",
    fill: "#8DC63F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5824 18.3867H22.9854C22.1392 18.3867 21.4531 19.0728 21.4531 19.919V24.516C21.4531 25.3622 22.1392 26.0483 22.9854 26.0483H27.5824C28.4286 26.0483 29.1147 25.3622 29.1147 24.516V19.919C29.1147 19.0728 28.4286 18.3867 27.5824 18.3867Z",
    fill: "#8DC63F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewalTrackingHamMenu);
export default __webpack_public_path__ + "static/media/Renewal_Tracking_ham_menu.3cf561b1ae049114859a1c63bfce4a93.svg";
export { ForwardRef as ReactComponent };